module.exports = __webpack_public_path__ + "static/img/Product_Inter.0d6fb82.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/phone/Product_Inter.png
// module id = t8qv
// module chunks = 1